import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const TenantAnalyticsDashboard = lazy(
    () => import('../components/TenantAnalyticsDashboard')
)

const TenantAnalyticsRoute: RouteObject = {
    path: 'tenant-onboard-analytics',
    element: <TenantAnalyticsDashboard />,
}

export default TenantAnalyticsRoute
